const BASE_URL = process.env.REACT_APP_XUXU_BASE_URL;
const MODEL_ID = process.env.REACT_APP_XUXU_MODEL_ID;

const API_KEY = process.env.REACT_APP_XUXU_API_KEY;
const PUBLIC_KEY = process.env.REACT_APP_XUXU_PUBLIC_KEY;
console.log("ENV", { BASE_URL, MODEL_ID, API_KEY, PUBLIC_KEY });
/**
 * Fetch contents for Works page.
 * - Supports optional type filter.
 * - Uses a single page (can be extended later).
 */
export async function fetchWorksContents({ type } = {}) {
    const params = new URLSearchParams();
    params.append("modelId", MODEL_ID);
    params.append("page", "0");
    params.append("size", "20");

    if (typeof type === "string") {
        params.append("type", type);
    }

    const response = await fetch(`${BASE_URL}/api/v1/projects/contents?${params.toString()}`, {
        method: "GET",
        headers: {
            "X-Api-Key": API_KEY,
            "X-Public-Key": PUBLIC_KEY,
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch works contents: ${response.status}`);
    }

    const data = await response.json();

    // Backend shape:
    // {
    //   message: "...",
    //   data: { page: { items: [...], pagination: {...} }, include: [] },
    //   status_code: 200
    // }
    const itemsFromPage = data?.data?.page?.items;

    if (Array.isArray(itemsFromPage)) {
        return itemsFromPage;
    }

    // Fallbacks in case the backend changes shape later
    const items =
        data?.items || data?.content || (Array.isArray(data?.data) ? data?.data : []) || [];

    return items;
}

